import React, { useState } from 'react';
import { Dialog, TextField } from '../../../../../components';
import { PANEL_FORM_DIALOG_TEXT } from '../../../lang';

type CreateTagDialogProps = {
  open: boolean;
  title: string;
  helpText: string;
  onClose: () => void;
  onCreate: (tagName: string) => void;
};

export const CreateTagDialog: React.FC<CreateTagDialogProps> = ({
  open,
  title,
  helpText,
  onClose,
  onCreate,
}) => {
  const [tagName, setTagName] = useState('');

  const handleCreate = (): void => {
    onCreate(tagName);
    setTagName('');
    onClose();
  };

  return (
    <Dialog
      openDialog={open}
      onDialogClose={onClose}
      dialogTitle={title}
      dialogAction={PANEL_FORM_DIALOG_TEXT.CREATE}
      cancelAction={PANEL_FORM_DIALOG_TEXT.CLOSE}
      onDialogAction={handleCreate}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: '1rem',
        }}
      >
        <TextField
          id="name"
          placeholder={helpText}
          type="text"
          value={tagName}
          fullWidth
          onChange={e => {
            setTagName(e.target.value);
          }}
        />
      </div>
    </Dialog>
  );
};
